<!-- START OF MAIN -->
<main class="site-main">
    <!-- START OF BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h2 class="h2-title mb-0 mt-5">Our Products</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF BANNER -->
    <!-- START OF SERVICES LISTING -->
    <section class="main-services-grid">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-xxl-3 col-sm-6" *ngFor="let prod of productsArr;let p = index;">
                    <div class="services-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="services-image">
                            <div class="back-img"
                                style="background-image: url({{prod?.image}});"></div>
                        </div>
                        <div class="services-box-icon">
                            <img src="assets/img/all-maintenance-icon.svg" width="38" height="38"
                                alt="All Maintenance Icon">
                        </div>
                        <div class="services-box-content">
                            <h5 class="h6-title">
                                <a routerLink="/product-details/{{prod?.id}}" [title]="prod?.name">{{prod?.name}}</a>
                            </h5>
                            <p class="porduct-list-description">{{prod?.description}}</p>
                            <a routerLink="/product-details/{{prod?.id}}" class="sec-btn icon-lg"
                                title="Go to All Maintenance"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF SERVICES LISTING -->

    <!-- START OF QUALITY SECTION -->
    <section class="best-quality light-bg">
        <div class="container">
            <div class="sec-title text-center wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                <span class="sub-title mb-0">
                    <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                    WHAT WE PROVIDE
                </span>
                <h2 class="h3-title mt-3 mb-4">We Provide Best Quality</h2>
            </div>
            <div class="sec-content">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="best-quality-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <span class="quality-icon">
                                <img src="assets/img/all-maintenance-icon.svg" width="38" height="38"
                                    alt="All Maintenance Icon">
                            </span>
                            <div class="quality-content">
                                <h4 class="h4-title">All Maintenance</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu nisi ut sem
                                    maximus suscipit. Donec malesuada ultricies eleifend. Duis hendrerit augue sit
                                    amet quam mollis.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="best-quality-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <span class="quality-icon">
                                <img src="assets/img/general-contract-icon.svg" width="33" height="37"
                                    alt="General Contract Icon">
                            </span>
                            <div class="quality-content">
                                <h4 class="h4-title">General Contract</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu nisi ut sem
                                    maximus suscipit. Donec malesuada ultricies eleifend. Duis hendrerit augue sit
                                    amet quam mollis.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="best-quality-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <span class="quality-icon">
                                <img src="assets/img/automobiles-icon.svg" width="35" height="35"
                                    alt="Automobiles Icon">
                            </span>
                            <div class="quality-content">
                                <h4 class="h4-title">Automobiles</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu nisi ut sem
                                    maximus suscipit. Donec malesuada ultricies eleifend. Duis hendrerit augue sit
                                    amet quam mollis.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="best-quality-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
                            <span class="quality-icon">
                                <img src="assets/img/mechanical-parts-icon.svg" width="35" height="35"
                                    alt="Mechanical Parts Icon">
                            </span>
                            <div class="quality-content">
                                <h4 class="h4-title">Mechanical Parts</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu nisi ut sem
                                    maximus suscipit. Donec malesuada ultricies eleifend. Duis hendrerit augue sit
                                    amet quam mollis.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF QUALITY SECTION -->
</main>
<!-- START OF FOOTER -->